import React from 'react';
interface SectionDividerProps {
  position: 'top' | 'bottom';
  fillColor: string;
  className?: string;
}
export function SectionDivider({
  position,
  fillColor,
  className = ''
}: SectionDividerProps) {
  const isTop = position === 'top';
  return <div className={`absolute left-0 right-0 w-full overflow-hidden leading-none z-10 ${isTop ? 'top-0 -translate-y-[99%]' : 'bottom-0 translate-y-[99%]'} ${className}`} data-id="element-403">
      <svg className="relative block w-full h-[50px] md:h-[100px]" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 120" preserveAspectRatio="none" style={{
      transform: isTop ? 'rotate(180deg)' : 'none'
    }} data-id="element-404">
        <path d="M321.39,56.44c58-10.79,114.16-30.13,172-41.86,82.39-16.72,168.19-17.73,250.45-.39C823.78,31,906.67,72,985.66,92.83c70.05,18.48,146.53,26.09,214.34,3V0H0V27.35A600.21,600.21,0,0,0,321.39,56.44Z" className={fillColor} data-id="element-405"></path>
      </svg>
    </div>;
}